import { useQuery } from "@tanstack/react-query";
import { getHostingSeason } from "@/api/event-about";

/**
 * The season ahead: the next festivals the caller has hosted for before,
 * with how the last one went. With none, the next national festivals.
 */
export function HostingSeasonPanel() {
  const { data, error } = useQuery({ queryKey: ["hosting-season"], queryFn: () => getHostingSeason(3) });
  const festivals = data?.data.festivals ?? [];
  return (
    <div className="card p-5">
      <h2 className="font-semibold mb-2">The season ahead</h2>
      {error && <p className="text-xs text-red-600">{(error as Error).message}</p>}
      <ul className="text-sm text-gray-700 space-y-1">
        {festivals.length === 0 && <li className="text-gray-500">No festival ahead in the calendar.</li>}
        {festivals.map((f) => (
          <li key={f.code}>
            {f.name} · {f.festivalDate}
            {f.lastTime
              ? ` · last time "${f.lastTime.title}": ${f.lastTime.went} went, ${f.lastTime.feedbackCount} reviews` +
                (f.lastTime.avgRating != null ? `, ${f.lastTime.avgRating.toFixed(1)}★` : "")
              : " · national"}
          </li>
        ))}
      </ul>
    </div>
  );
}
